import moment from 'moment'

export const PERIOD_STORAGE_KEY = 'overview/period'

export const PRESETS = [
  { key: '24h', label: 'dash.overview.period.24h' },
  { key: '7d', label: 'dash.overview.period.7d', days: 7 },
  { key: '30d', label: 'dash.overview.period.30d', days: 30 },
  { key: '90d', label: 'dash.overview.period.90d', days: 90 },
  { key: '365d', label: 'dash.overview.period.365d', days: 365 },
  { key: 'all', label: 'dash.overview.period.all' }
]

export const DEFAULT_PERIOD = { key: '30d' }

// Bornes arrondies (heure / jour) pour que le cache serveur soit réutilisé d'un affichage à l'autre
export function periodRange(period) {
  const key = period && period.key
  if (key === 'all') return { since: null, until: null }
  if (key === '24h') {
    const until = moment().endOf('hour')
    return { since: until.clone().subtract(24, 'hours').add(1, 'second').unix(), until: until.unix() }
  }
  if (key === 'custom' && period.start && period.end) {
    return { since: moment(period.start).startOf('day').unix(), until: moment(period.end).endOf('day').unix() }
  }
  const preset = PRESETS.find(p => p.key === key) || PRESETS.find(p => p.key === DEFAULT_PERIOD.key)
  const until = moment().endOf('day')
  return { since: until.clone().subtract(preset.days - 1, 'days').startOf('day').unix(), until: until.unix() }
}

export function loadStoredPeriod() {
  try {
    const raw = localStorage.getItem(PERIOD_STORAGE_KEY)
    const period = raw ? JSON.parse(raw) : null
    if (period && (PRESETS.some(p => p.key === period.key) || (period.key === 'custom' && period.start && period.end))) return period
  } catch (e) {
    // stockage indisponible ou valeur corrompue
  }
  return null
}

export function storePeriod(period) {
  try {
    localStorage.setItem(PERIOD_STORAGE_KEY, JSON.stringify(period))
  } catch (e) {
    // stockage indisponible
  }
}

// Dates exactes couvertes par une période (Tooltip des boutons de période)
export const presetHelp = (vm, preset) => {
  if (preset.key === 'all') return vm.$t('dash.overview.help.period.all')
  const { since, until } = periodRange(preset)
  const fmt = preset.key === '24h' ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'
  return vm.$t('dash.overview.help.period.range', { start: moment.unix(since).format(fmt), end: moment.unix(until).format(fmt) })
}

export const periodLabel = (vm, period) => {
  if (period.key === 'custom')
    return `${moment(period.start).format('DD/MM/YYYY')} → ${moment(period.end).format('DD/MM/YYYY')}`
  const preset = PRESETS.find(p => p.key === period.key)
  return preset ? vm.$t(preset.label) : ''
}
